import privateAxiosInstance from "../utils/axios/private";
import { hybridEncrypt, hybridDecrypt } from "../utils/crypto";

export const manualQuestionApi = {
    // GET Questions
  async getQuestions(jobId) {
    try {

        const response =
            await privateAxiosInstance.get(
                "/manual/question/",
                {
                    params: {
                        job_id: jobId
                    }
                }
            );

        if (response.data.encrypted) {
            return await hybridDecrypt(
                response.data
            );
        }

        return response.data;

    } catch (error) {
        if (error.code === "ERR_NETWORK") {
    return {
        status: 0,
        message:
            "Network error. Please check your internet connection.",
        type: "network_error",
    };
}

return error.response?.data;
    }
},

    // CREATE Question
    async createQuestion(payload) {
        try {
            const encryptedPayload =
                await hybridEncrypt(payload);

            const response =
                await privateAxiosInstance.post(
                    "/manual/question/",
                    encryptedPayload
                );

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;

        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    message: "Network error",
                };
            }

            if (error.code === "ERR_NETWORK") {
    return {
        status: 0,
        message:
            "Network error. Please check your internet connection.",
        type: "network_error",
    };
}

return error.response?.data;
        }
    },


    async updateQuestion(id, payload) {
    try {

        const encryptedPayload =
            await hybridEncrypt(payload);

        const response =
            await privateAxiosInstance.put(
                `/manual/question/${id}/`,
                encryptedPayload
            );

        if (response.data.encrypted) {
            return await hybridDecrypt(
                response.data
            );
        }

        return response.data;

    } catch (error) {
        return error.response?.data;
    }
},

async deleteQuestion(id) {
    try {

        const response =
            await privateAxiosInstance.delete(
                `/manual/question/${id}/`
            );

        if (response.data.encrypted) {
            return await hybridDecrypt(
                response.data
            );
        }

        return response.data;

    } catch (error) {
        return error.response?.data;
    }
},
};